<template>
    <div>
        <buttonlist
                @help="help"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <div style="margin-top: 2px">
            <el-button type="primary" size="mini" @click="transfer" :disabled="!btn.transfer">{{ $t('getapi[6023]') }}</el-button>
            <!-- <el-button type="primary" size="mini" @click="transferwithdate">{{ $t('getapi[7211]')}}</el-button> -->
            <el-button type="primary" size="mini" @click="toORderListExcel" :disabled="selectData.length<1||selectData.length>300">{{$t('getapi[8221]')}}</el-button>
        </div>
        <div id="xpane-0">
        <vxe-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                resizable
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                @checkbox-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                @sort-change="sortChange"
                :default-sort="sortRule"
                @checkbox-all="handleSelectionChangeAll"
                @checkbox-range-end="handleSelectionChange"
                :checkbox-config="{highlight: true, range: true}"
                :mouse-config="{selected:true, extension: true}"
                ref="singleTable"
        >
            <vxe-table-column type="checkbox" align="center" width="40"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="exclusively_num"  width="80px" :title="$t('getapi[1297]')"></vxe-table-column>
            <!-- <vxe-table-column show-overflow-tooltip field="llc" :title="$t('getapi[7212]')" align="right"></vxe-table-column> -->
            <vxe-table-column show-overflow-tooltip field="kcqty" :title="$t('getapi[2576]')" width="80px" align="right"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="partid" :title="$t('getapi[503]')" width="100px"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="llc" :title="$t('getapi[7212]')" width="50px" align="right"></vxe-table-column>
            <vxe-table-column field="partcode" :title="$t('getapi[112]')" width="100px">
                <template slot-scope="scope" >
                    <span v-if="scope.row.suggest_order_date != scope.row.with_order_date && scope.row.with_order_date != ''" style="color:red">
                        {{scope.row.partcode}}
                    </span>
                    <span v-if="scope.row.suggest_order_date == scope.row.with_order_date || scope.row.with_order_date == ''">
                        {{scope.row.partcode}}
                    </span>
                </template>
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="partversion" :title="$t('getapi[149]')" width="100px"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="part_model" :title="$t('getapi[124]')" width="100px"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="part_spec" :title="$t('getapi[125]')" width="100px"></vxe-table-column>
            <!-- <vxe-table-column show-overflow-tooltip field="part_master_unit" :title="$t('getapi[4590]')"  ></vxe-table-column> -->
            <!-- <vxe-table-column show-overflow-tooltip field="calc_date" :title="$t('getapi[4053]')" width="100px"></vxe-table-column> -->
            <vxe-table-column field="calc_date" :title="$t('getapi[4053]')" width="100px">
                <template slot-scope="scope" >
                    {{scope.row.calc_date | timeFormat}}
                </template>
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="calc_qty" :title="$t('getapi[1628]')" width="70px" align="right"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="measure_unit" :title="$t('getapi[888]')" width="100px"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="item_code" :title="$t('getapi[876]')" width="100px"></vxe-table-column>
            <vxe-table-column field="suggest_order_date" :title="$t('getapi[7213]')" width="120px">
                <template slot-scope="scope" >
                    {{scope.row.suggest_order_date | timeFormat}}
                </template>
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="default_schedule_person" :title="$t('getapi[7214]')" width="100px"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="mp_flag" :title="$t('getapi[4241]')" width="100px"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="lead_time" :title="$t('getapi[7215]')" align="right" width="80px"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="accumulate_leadtime" :title="$t('getapi[8058]')" align="right" width="100px"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="products" :title="$t('getapi[145]')" width="100px"></vxe-table-column>
            <!-- <vxe-table-column show-overflow-tooltip field="qc_leadtime" :title="$t('getapi[6006]')"
                             align="right"  width="100px"></vxe-table-column> -->
            <vxe-table-column show-overflow-tooltip field="part_engtype_name"
                             :title="$t('getapi[118]')"  width="100px"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="remark"
                              :title="$t('getapi[143]')"  width="100px"></vxe-table-column>
            <!-- <vxe-table-column show-overflow-tooltip field="with_order_date" :title="$t('getapi[7216]')"  width="120px">
                <template slot-scope="scope" >
                    <span v-if="scope.row.suggest_order_date != scope.row.with_order_date && scope.row.with_order_date != ''" style="color:red">
                        {{scope.row.with_order_date}}
                    </span>
                    <span v-if="scope.row.suggest_order_date == scope.row.with_order_date || scope.row.with_order_date == ''">
                        {{scope.row.with_order_date}}
                    </span>
                </template>
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="with_days" :title="$t('getapi[153]')" width="80px"
                             align="right"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="with_sort"  width="80px" :title="$t('getapi[7217]')" align="right"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="with_remark" width="100px" :title="$t('getapi[7218]')"></vxe-table-column>
             -->
            <vxe-table-column show-overflow-tooltip field="dataType"   v-if="false"></vxe-table-column>
       
        </vxe-table>
        </div>
        <!-- <div style="width:100%;height:20px;text-align: center">
            <span style="color:red;font-size: 20px">{{$t('getapi[7219]')}}{{num}}{{$t('getapi[7220]')}}</span>
        </div> -->
        <el-row>
            <span style="font-size: 20px">{{$t('getapi[201]')}}{{total}}{{$t('getapi[6771]')}}</span>
        </el-row>
        <serce :isVisible="isVisible" queryData="MRP_TranOrder_Pur" ref="ser" @getser="serclick"></serce>

        <selector :isVisible="false"  :isBatch=false :isSplitPage=true :postUrl="'/MRP/Tool/GetMRPItemPopupList'" @callback="getitem" ref="input"></selector>

        <el-dialog v-dialogDrag :visible.sync="isShowTransfer" :title="$t('getapi[6023]')" width="15%" :modal-append-to-body="false">
            <div>
                <table>
                    <tr>
                        <td>{{$t('getapi[1480]')}}</td>
                        <td>
                            <el-input v-model="requisition_no" type="text" size="mini" style="width:120px"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[4158]')}}</td>
                        <td>
                            <routejump :urlNo="5">
                            <el-input
                                    v-model="item_code"
                                    type="text"
                                    readonly
                                    size="mini"
                                    style="width:120px"
                            >
                                <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectitem()"></i>
                            </el-input>
                            </routejump>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowTransfer = false" size="mini">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="confirmTransfer" :disabled="!btnsave" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '2_mrptranssrorder',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3 - Common.reduceTableHeight3
            },
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 100000, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                selectData: [],
                requisition_no: '', // 计划标识
                item_code: '', // 项目编码
                isShowTransfer: false,
                btn: {
                    transfer: false
                },
                num: 0, // 建议合并转单的数量
                btnsave:false,
                scrollTop:0,
                sortRule: {property:null,order:null},
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0)
                    }, 500);
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12439]"),'MRP');
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                that.btnauthority()
            },
            btnauthority() {
                let that = this;
                that.btn.transfer = false
                if (that.selectData.length > 0) {
                    that.btn.transfer = true
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('2_mrptranssrorder',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'MRP_TranOrder_SR');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            handleSelectionChange({checked, records }) {
                let that = this;
                that.selectData = records;
                that.btnauthority()
            },
            //全选
            handleSelectionChangeAll({ records }){
                let that = this;
                that.selectData = records;
                that.btnauthority()
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/MRP/Tool/GetMrpTranSrView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.selectData = []
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                        that.getInfo()
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            getInfo(){
              let that = this
              that.num = 0
              for(let i=0;i<that.dataSet.length;i++){
                  if(that.dataSet[i].suggest_order_date == that.dataSet[i].with_order_date && that.dataSet[i].with_order_date != ''){
                      that.num ++
                  }
              }
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac,
                    LangType:that.$processdata.getLang(),
                    fromname: that.$t('getapi[12439]')
                };
                that.$http.urlpost('/MRP/Tool/GetMrpTranSrViewToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            selectitem() {
                let that = this;
                that.$refs.input.clearInput(true);
            },
            getitem(val) {
                let that = this;
                that.item_code = val.item_name;
            },
            // 转单
            transfer() {
                let that = this;
                that.isShowTransfer = true;
                that.requisition_no = ''
                that.item_code = ''
                that.btnsave=true;
            },
            confirmTransfer() {
                let that = this;
                that.btnsave=false;
                let parm = {
                    srcode_prefix: that.requisition_no,
                    item_code: that.item_code,
                    Lists: that.selectData[0],
                    LangType: that.$processdata.getLang(),
                }                
                that.$http.urlpost('/MRP/Tool/MrpTranSR', parm, function (res) {
                    that.btnsave=true;
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        for(let i=that.dataSet.length-1;i>=0;i--){
                            for(let j=that.selectData.length-1;j>=0;j--){
                                if(that.dataSet[i].exclusively_num == that.selectData[j].exclusively_num){
                                    that.dataSet.splice(i,1)
                                }
                            }
                        }
                        that.isShowTransfer = false;
                    }
                });
            },
            // 计算合并下单
            transferwithdate() {
                let that = this
                that.$http.urlpost('/MRP/Tool/MRPTranOrderWithDate', '', function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            sortChange(column){
                let that = this
                let name = column.property
                if(column.order == "asc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return that.dataSet.indexOf(obj1) - that.dataSet.indexOf(obj2);
                        }
                    }
                    that.dataSet.sort(compare);
                    that.dataSet = [...that.dataSet]
                } else if(column.order == "desc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return 1;
                        } else if (val1 > val2) {
                            return -1;
                        } else {
                            return that.dataSet.indexOf(obj2) - that.dataSet.indexOf(obj1);
                        }
                    }
                    that.dataSet.sort(compare);
                    that.dataSet = [...that.dataSet]
                }
                that.sortRule.order = column.order
                that.sortRule.property = column.property
            },
            toORderListExcel(){
                let that = this
                let arr= []
                for(let i=0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        part_code:that.selectData[i].partcode
                    }]
                }
                that.$store.commit('setSharedParams',{
                    Code: '',
                    List: arr
                });
                let item = {
                    label: this.$t("getapi[8221]"),
                    name: "2_orderlisttoexcel",
                    path: "/orderlisttoexcel",
                    url: "SO/orderlisttoexcel",
                    icon: 'arrow-right'
                };
                this.$router.push({
                    name: '2_orderlisttoexcel',
                    label: this.$t('getapi[8221]'),
                    path: '/orderlisttoexcel',
                });
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
